import styled from "styled-components";

type StyledTransactionsTableProps = {
  width?: number
}

export const Wrapper = styled.div`
  width: 100%;
  margin-top: 40px;
  font-family: Inter;

  & div[title="account-card"]:not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const HeaderText = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: -0.02em;
  color: #000000;
  font-family: Inter;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Inter;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) {
    display: block;
  }
`;

export const StyledAccountsTable = styled.div<StyledTransactionsTableProps>`
  font-family: "Inter";
  margin-top: ${props => props.width > 768 ? '35px' : '0'};
  overflow: hidden;
  border-top: ${props => props.width > 768 ? '1px solid #f0f0f0' : 'none'};

  .transaction-list {
    display: flex;
    justify-content: space-between;
  }

  h3 {
    margin: 20px;
    font-weight: 500;
    font-size: 18px;
    color: #000000;
    line-height: 28px;

    @media (max-width: 768px) {
      margin: 0;
      margin-bottom: 1.5rem;
    }
  }

  @media (min-width: 768px) {
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    margin-top: 35px;
  }
`;

export const EditButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 5px;
  display: flex;
  align-items: center;
  & span {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 160%;
    color: var(--primary-brand);
    margin-right: 8px;
  }
`;

export const ButtonDiv = styled.div`
  display: flex;
  justify-content: start;
  margin: 16px;

  & > button {
    padding: 12px 20px;
    height: 40px;
    background-color: #000000;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
  }
  & > button > span {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #ffffff;
  }
  & svg path {
    stroke: #000000;
  }

  @media (max-width: 767px) {
    margin-left: 0px;
  }
`;

export const EmptyWrapper = styled.div`
  font-family: "Inter";
`;

export const EmptyWrapperTitle = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.02em;
  color: #000000;
  margin-bottom: 8px;
`;

export const EmptyWrapperSubTitle = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 160%;
  text-align: center;
  color: #464646;
  margin-bottom: 24px;
`;

export const EmptyWrapperButton = styled.button`
  //padding: 12px 20px;
  width: 128px;
  height: 40px;
  background: #000000;
  border-radius: 6px;
  color: #ffffff;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  border: unset;
`;

export const DropdownContainer = styled.div`
  width: 10rem;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  align-items: center;

  @media (max-width: 767px) {
    position: relative;
    align-items: flex-end;
    width: 100%;
    flex-direction: column;

    & > p {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 130%;
      color: #8f8f8f;
    }
  }
`